'use strict'

import {Person} from 'janux-people'
import _ from 'lodash'

export function contactService (http) {
	const hydrateContact = (contact) => {
		let person = Person.fromJSON(contact)
		person.contactId = contact.contactId
		person.typeId = contact.typeId
		person.userId = contact.userId
		person.projId = contact.projId
		person.company = (_.isNil(contact.company)) ? '' : contact.company
		return person
	}

	const dehydrateContact = (contact) => {
		const attrs = _.clone(contact)
		let data = contact.toJSON()
		data.typeId = attrs.typeId
		data.userId = attrs.userId
		data.projId = attrs.projId
		data.company = (_.isNil(attrs.company)) ? '' : attrs.company

		if (!_.isNil(attrs.contactId)) {
			data.contactId = attrs.contactId
		}

		return data
	}

	return {
		// Load contacts by user id
		findContactsByUserId: function (userId) {
			return http.jsonrpc(
				'/rpc/2.0/contacts',
				'findContactsByUserId',
				[ userId ]
			).then((resp) => {
				const out = _.mapValues(resp.result, (contact) => {
					return hydrateContact(contact)
				})

				return out
			})
		},
		// Load contact by id
		findContactById: function (contactId) {
			return http.jsonrpc(
				'/rpc/2.0/contacts',
				'findContactById',
				[ contactId ]
			).then((resp) => {
				return (!_.isNil(resp.result)) ? hydrateContact(resp.result) : resp.result
			})
		},
		// Load contact by id
		findContactByUserIdAndType: function (userId, type) {
			return http.jsonrpc(
				'/rpc/2.0/contacts',
				'findContactByUserIdAndType',
				[ userId, type ]
			).then(function (resp) {
				console.debug('findContactByUserIdAndType response', resp.result)
				return (!_.isNil(resp.result)) ? hydrateContact(resp.result) : resp.result
			})
		},
		// Load contact by id
		findContactByProjIdAndType: function (projId, type) {
			return http.jsonrpc(
				'/rpc/2.0/contacts',
				'findContactByProjIdAndType',
				[ projId, type ]
			).then(function (resp) {
				console.debug('findContactByProjIdAndType response', resp.result)
				return (!_.isNil(resp.result)) ? hydrateContact(resp.result) : resp.result
			})
		},
		// Add new contact
		insert: function (contact) {
			const data = dehydrateContact(contact)
			console.debug('Inserting contact', contact)

			return http.jsonrpc(
				'/rpc/2.0/contacts',
				'insert',
				[ data ]
			).then(function (resp) {
				console.debug('contact insert response', resp.result)
				return (!_.isNil(resp.result)) ? hydrateContact(resp.result[0]) : resp.result
			})
		},
		// save contact changes
		update: function (contact) {
			const data = dehydrateContact(contact)
			console.debug('Updating contact', contact)

			return http.jsonrpc(
				'/rpc/2.0/contacts',
				'update',
				[ data ]
			).then(function (resp) {
				console.debug('contact update response', resp.result)
				return (!_.isNil(resp.result)) ? hydrateContact(resp.result[0]) : resp.result
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/e24-services/contact-service.js